// src/components/store/sections/blog-posts/BlogV50MinimaljournalIndigoPulse.tsx
"use client";

import React from "react";
import DynamicBlogVariant from "./DynamicBlogVariant";

export default function BlogV50MinimaljournalIndigoPulse(props: any) {
  return (
    <DynamicBlogVariant
      variantNumber={50}
      archKey="minimal_journal"
      archLabel="Minimalist Journal Strip"
      palName="IndigoPulse"
      grad="from-indigo-500 via-blue-600 to-violet-700"
      lightBg="bg-indigo-50"
      textCol="text-indigo-700"
      borderCol="border-indigo-200"
      btnCls="bg-indigo-600 hover:bg-indigo-700"
      hexCol="#6366f1"
      {...props}
    />
  );
}
